import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { SmtFile } from '../../../../../../../types/Form';
import LinksInput from './LinksInput';

interface Props {
  question: FlowsQuestion;
  isEditable?: boolean;
}

const LinksInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  isEditable,
}) => {
  const {
    field: { value, onBlur },
    error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const uploadedFiles = (value as SmtFile[] | undefined) || [];

  const handleOnChange = (files: SmtFile[]) => {
    onBlur({
      name: question.id,
      value: files,
    });
  };

  return (
    <LinksInput
      value={uploadedFiles}
      onChange={handleOnChange}
      supportedLinkFormats={
        question.rules.options?.supported_mime_types ||
        question.rules.supported_mime_types
      }
      error={error}
      isDisabled={question.rules.is_disabled}
      withLink
      isEditable={isEditable}
    />
  );
};

export default LinksInputComponent;
